import { ipstackAccessKey } from "environment";

const axios = require("axios");

export default async function () {
  // Fetch the country code
  let countryCode = null;
  try {
    const ipLookupResponse = await axios.get(
      `https://api.ipstack.com/check?access_key=${ipstackAccessKey}`
    );
    countryCode = ipLookupResponse.data.country_code;
  } catch (e) {
    console.log(e);
  }
  return countryCode;
}
